export default {
      id: "checked-icon-usage",
      viewBox: "0 0 90 71",
      url: __webpack_public_path__ + "icons-sprite.f57ad8e.svg#checked-icon-usage",
      toString: function () {
        return this.url;
      }
    }